/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamListForItemFilterViewModel } from "../types/ExamListForItemFilterViewModel.ts";

export const examListForItemFilterViewModelSchema = z.object({
  disciplineId: z.number().int().nullish(),
  companyId: z.number().int().nullish(),
  pageNumber: z.optional(z.number().int()),
  pageSize: z.optional(z.number().int()),
  sortField: z.string().nullish(),
  sortDirection: z.string().nullish(),
}) as unknown as ToZod<ExamListForItemFilterViewModel>;
